export const NOTHING = '';
export const TYPE_EDITION_COMMISSSIONS_VENDEUR = 'CommissionVendeur';
